module.exports = __webpack_public_path__ + "static/PP1-290e8b72438a6301c8815ef9302c06ef.jpg";